function e(r){return new URL(r).origin}export{e as a};
